import { render, staticRenderFns } from "./QuillEditorPreview.vue?vue&type=template&id=60b895e0&class=mt-5&"
import script from "./QuillEditorPreview.vue?vue&type=script&lang=js&"
export * from "./QuillEditorPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports